import { useNavigate } from "react-router-dom";
import { MenuItem } from "@mui/material";
import { MenuItemType, MenuPropsType } from "../../../types/component.type";
import { SideNavigationMenuWrapper } from "./styled";
import { AppContext } from "../../../context/appContext";
import { useContext } from "react";

export const SideNavigationMenu: React.FC<MenuPropsType<MenuItemType>> = ({ open, menuitems }) => {
    const navigate = useNavigate();
    const { setIsMobileSideNavigationOpen } = useContext(AppContext);

    const handleNavigate = (e: React.MouseEvent<HTMLLIElement, MouseEvent>, path: string) => {
        e.stopPropagation();
        navigate(path);
        return setIsMobileSideNavigationOpen(false);
    };

    return (
        <SideNavigationMenuWrapper
            open={open}
        >
            <ul>
                {menuitems?.map((item: Record<any, any>, index: string) => {
                    return (
                        <MenuItem
                            key={index}
                            className={`${item.name.replace(/\s+/g, '-')}-Side-Nav-Button`}
                            onClick={(e) => handleNavigate(e, item.url.replace(/\s+/g, '').toLowerCase())}
                        >
                            {item.name}
                        </MenuItem>
                    )
                })}
            </ul>
        </SideNavigationMenuWrapper>
    )
}
